import { z } from "zod";
/**
 * Module Progress Schema for DynamoDB
 *
 * Progress is stored with denormalized module info for efficient queries.
 *
 * PK: USER#<uid>
 * SK: PROGRESS#MODULE#<moduleId>
 */
// Base ModuleProgress schema for DynamoDB
// Matches server ProgressRepository.itemToModuleProgress() output
export const ModuleProgressSchema = z.object({
    user_uid: z.string(),
    module_id: z.number().int(),
    course_id: z.number().int(),
    status: z.enum(["not_started", "in_progress", "completed"]),
    exercises_completed: z.number().int().min(0).default(0),
    exercises_total: z.number().int().min(0).default(0),
    completion_percentage: z.number().min(0).max(100).default(0),
    /** Time spent on this module in seconds (raw data) */
    time_spent_seconds: z.number().min(0).default(0),
    completed_at: z.date().nullable(),
});
// Payload schema for creating/updating module progress
export const ModuleProgressPayloadSchema = z.object({
    user_uid: z.string(),
    module_id: z.number().int(),
    course_id: z.number().int(),
    exercises_total: z.number().int().min(0).optional(),
});
// Schema for course module progress with module details (alias)
export const CourseModuleProgressSchema = ModuleProgressSchema;
// Schema for module progress statistics
export const ModuleProgressStatsSchema = z.object({
    total_users_started: z.number().int().min(0),
    total_users_completed: z.number().int().min(0),
    average_completion_percentage: z.number().min(0).max(100),
    /** Average time spent per user, in minutes (derived display stat) */
    average_time_spent_minutes: z.number().min(0),
    completion_rate: z.number().min(0).max(100),
});
// Schema for leaderboard entries
export const ModuleLeaderboardEntrySchema = z.object({
    user_uid: z.string(),
    user_name: z.string().nullable(),
    completion_percentage: z.number().min(0).max(100),
    time_spent_seconds: z.number().min(0),
    status: z.enum(["not_started", "in_progress", "completed"]),
});
// Schema for filters used in queries
export const ModuleProgressFiltersSchema = z
    .record(z.string(), z.union([
    z.string(),
    z.number(),
    z.boolean(),
    z.date(),
    z.array(z.union([z.string(), z.number(), z.boolean()])),
]))
    .optional();
